import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ScrollToTop from "@/components/feature/ScrollToTop";

export default function AboutPage() {
  const [formSuccess, setFormSuccess] = useState(false);
  const [formError, setFormError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const formSubmitAddr = "https://readdy.ai/api/form/d9spig14ne17ei0sdlog";

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormError("");
    setSubmitting(true);

    const form = e.currentTarget;
    const formData = new FormData(form);
    const phoneAlt = formData.get("phone_alt");
    if (phoneAlt && typeof phoneAlt === "string" && phoneAlt.trim() !== "") {
      setFormSuccess(true);
      form.reset();
      setSubmitting(false);
      return;
    }

    try {
      const body = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== "phone_alt") body.append(key, value as string);
      });

      const res = await fetch(formSubmitAddr, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      const responseText = await res.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || responseText || "";

      if (res.ok && parsed?.code === "OK") {
        setFormSuccess(true);
        form.reset();
      } else {
        setFormError(serverMsg || "提交失败，请稍后重试");
      }
    } catch {
      setFormError("网络错误，请检查连接后重试");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main className="pt-20">
        <div className="bg-background-100 border-b border-background-200/70">
          <Breadcrumb
            items={[{ label: "首页", href: "/" }, { label: "关于我们" }]}
          />
          <div className="px-4 md:px-6 lg:px-10 pb-10">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                关于我们
              </h1>
              <p className="text-sm text-foreground-600 leading-relaxed">
                了解女王调教指南的品牌理念、专业背景与核心价值
              </p>
            </div>
          </div>
        </div>

        {/* Brand Introduction */}
        <section className="px-4 md:px-6 lg:px-10 py-14">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div>
                <h2 className="text-xl font-heading font-bold text-foreground-900 mb-4">
                  品牌介绍
                </h2>
                <div className="space-y-3 text-sm text-foreground-700 leading-relaxed">
                  <p>
                    女王调教指南成立于2024年，是国内首批专注于女王调教与支配关系教育的专业内容平台。我们致力于为对支配与臣服（D/s）关系感兴趣的成年人提供权威、安全、知情的指导内容。
                  </p>
                  <p>
                    我们的团队由资深关系咨询师、心理学研究者和经验丰富的实践者组成，所有内容均经过严格的专业审核，确保信息的准确性和安全性。我们坚信，健康的女王调教关系应当建立在<strong>知情同意、相互尊重和安全规范</strong>三大基石之上。
                  </p>
                  <p>
                    无论您是初入这个世界的新人，还是希望精进技巧的经验者，我们都为您准备了从入门到进阶的系统化内容，帮助您在安全的环境中探索和成长。
                  </p>
                </div>
              </div>
              <div className="relative aspect-[4/3] rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20abstract%20composition%20with%20warm%20beige%20and%20cream%20gradients%2C%20sophisticated%20flowing%20organic%20shapes%2C%20professional%20editorial%20aesthetic%2C%20clean%20refined%20atmosphere%2C%20no%20people%2C%20fine%20art%20style%20with%20gentle%20textures&width=800&height=600&seq=about-brand-01&orientation=landscape"
                  alt="品牌理念"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Core Values */}
        <section className="px-4 md:px-6 lg:px-10 py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-xl font-heading font-bold text-foreground-900 text-center mb-10">
              我们的核心价值观
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center bg-primary-50 rounded-full">
                  <i className="ri-shield-check-line text-2xl text-primary-500"></i>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                  安全第一
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们严格遵循SSC和RACK安全原则，所有内容始终将参与者安全放在首位。
                </p>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center bg-accent-100 rounded-full">
                  <i className="ri-book-open-line text-2xl text-accent-500"></i>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                  专业权威
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  内容由专业人士编审，融合心理学理论与实践经验，确保信息准确可靠。
                </p>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center bg-secondary-100 rounded-full">
                  <i className="ri-heart-line text-2xl text-secondary-500"></i>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                  尊重包容
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们尊重多元化表达，倡导包容与理解，杜绝任何形式的歧视与偏见。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Reputation */}
        <section className="px-4 md:px-6 lg:px-10 py-14">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-xl font-heading font-bold text-foreground-900 mb-8">
              平台信誉
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-5">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-primary-50 rounded-full">
                    <i className="ri-article-line text-xl text-primary-500"></i>
                  </div>
                  <h3 className="text-sm font-heading font-semibold text-foreground-900">
                    16+ 篇专业原创文章
                  </h3>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  涵盖五大核心分类，从入门到进阶，系统化知识体系持续更新。
                </p>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-5">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-accent-100 rounded-full">
                    <i className="ri-user-star-line text-xl text-accent-500"></i>
                  </div>
                  <h3 className="text-sm font-heading font-semibold text-foreground-900">
                    专业编审团队
                  </h3>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  由关系咨询师和资深实践者组成的团队确保内容的专业性和安全性。
                </p>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-5">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-secondary-100 rounded-full">
                    <i className="ri-shield-star-line text-xl text-secondary-500"></i>
                  </div>
                  <h3 className="text-sm font-heading font-semibold text-foreground-900">
                    安全导向内容审核
                  </h3>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  所有内容经过多轮安全审核，确保每篇文章都符合SSC和RACK安全标准。
                </p>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-lg p-5">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-primary-50 rounded-full">
                    <i className="ri-global-line text-xl text-primary-500"></i>
                  </div>
                  <h3 className="text-sm font-heading font-semibold text-foreground-900">
                    中文原创内容
                  </h3>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  所有内容均为中文原创，针对中文使用者的文化背景和需求精心打造。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <section className="px-4 md:px-6 lg:px-10 py-14 bg-background-100">
          <div className="max-w-2xl mx-auto">
            <h2 className="text-xl font-heading font-bold text-foreground-900 text-center mb-3">
              联系我们
            </h2>
            <p className="text-sm text-foreground-500 text-center mb-8">
              有任何问题、建议或合作意向？请填写以下表单，我们会尽快回复。
            </p>

            {formSuccess ? (
              <div className="bg-accent-50 border border-accent-200/70 rounded-lg p-8 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center bg-accent-100 rounded-full">
                  <i className="ri-check-line text-2xl text-accent-500"></i>
                </div>
                <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">
                  提交成功！
                </h3>
                <p className="text-sm text-foreground-600">
                  感谢您的留言，我们会在1-2个工作日内回复您。
                </p>
              </div>
            ) : (
              <form
                onSubmit={handleSubmit}
                data-readdy-form
                className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label
                      htmlFor="name"
                      className="block text-sm font-medium text-foreground-700 mb-1.5"
                    >
                      姓名 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      className="w-full px-3 py-2 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium text-foreground-700 mb-1.5"
                    >
                      邮箱 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      className="w-full px-3 py-2 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                </div>

                <div className="mb-4">
                  <label
                    htmlFor="subject"
                    className="block text-sm font-medium text-foreground-700 mb-1.5"
                  >
                    主题
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    className="w-full px-3 py-2 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="请输入留言主题"
                  />
                </div>

                <div className="mb-4">
                  <label
                    htmlFor="message"
                    className="block text-sm font-medium text-foreground-700 mb-1.5"
                  >
                    留言内容 <span className="text-primary-500">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    maxLength={500}
                    rows={5}
                    className="w-full px-3 py-2 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                    placeholder="请输入您的留言内容（最多500字符）"
                  ></textarea>
                  <p className="text-xs text-foreground-400 mt-1">
                    最多500字符
                  </p>
                </div>

                <input
                  type="text"
                  name="phone_alt"
                  className="form-hp"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />

                {formError && (
                  <div className="mb-4 p-3 bg-primary-50 border border-primary-200 rounded-md">
                    <p className="text-sm text-primary-700">{formError}</p>
                  </div>
                )}

                <button
                  type="submit"
                  disabled={submitting}
                  className="w-full sm:w-auto px-6 py-2.5 bg-primary-500 text-white text-sm font-medium rounded-md hover:bg-primary-600 disabled:opacity-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {submitting ? "提交中..." : "提交留言"}
                </button>
              </form>
            )}
          </div>
        </section>
      </main>

      <Footer />

      {/* JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "关于我们 - 女王调教指南",
            "description":
              "了解女王调教指南的品牌理念、专业背景与核心价值",
            "url": window.location.href,
            "about": {
              "@type": "Organization",
              "name": "女王调教指南",
              "description":
                "国内首批专注于女王调教与支配关系教育的专业内容平台，提供权威、安全、知情的指导内容。",
              "foundingDate": "2024",
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "首页",
                  "item": window.location.origin,
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "关于我们",
                },
              ],
            },
          }),
        }}
      />
    </>
  );
}